/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  requestGetReport05
} from 'app/api/report'
import { ReportMessageCode } from 'app/api/report/constant'
import {
  IParamsGetReport05,
  IResponseGetReport05,
} from 'app/api/report/model/report-05'
import { useBaseTableReportHook } from 'app/components/tables/BaseTableReport/hook'
import {
  IDataBaseTable,
  IParamsHookReport,
} from 'app/components/tables/BaseTableReport/type'
import { isEqual } from 'lodash'
import { Pagination } from 'parkway-web-common'
import { convertGeneralReport05Value, useCommonHook } from '../common-hook'
import { IDataReport05Weekly, initialPagination } from './data'

export const useTableWeeklyHook = (props: IParamsHookReport) => {
  const getDataWeek = async (
    pagination: Pagination,
    params: IParamsGetReport05,
  ) => {
    const initData = {
      pagination: pagination ?? initialPagination,
      data: [],
    } as IDataBaseTable<IDataReport05Weekly>
    try {
      const response: IResponseGetReport05 = await requestGetReport05({
        month: props?.month,
        year: props?.year,
        ...params,
        option: 'week',
      })
      if (
        isEqual(response?.msgcode, ReportMessageCode.Report05.successGetData)
      ) {
        const data = response?.data?.rows ?? []
        const dataTable: IDataReport05Weekly[] =
          data?.map((area, index) => {
            const [firstClinic, ...otherClinics] = area?.children ?? []

            const dataOfFirstClinic = convertGeneralReport05Value({
              clinic: firstClinic,
              type: 'clinic',
              typeHook: 'week',
            })

            const dataOfArea = convertGeneralReport05Value({
              area,
              type: 'area',
              typeHook: 'week',
            })

            const newResponse: IDataReport05Weekly = {
              key: index + 1,
              ...dataOfFirstClinic,
              ...dataOfArea,
              children: otherClinics?.map((clinic, idx) => {
                const dataOfClinic = convertGeneralReport05Value({
                  clinic,
                  type: 'clinic',
                  typeHook: 'week',
                })

                return {
                  key: (index + 1) * 100 + idx + 1,
                  index: idx + 1,
                  ...dataOfClinic,
                }
              }),
            }
            return newResponse
          }) ?? []
        const metadata = response?.data?.metadata?.total
        const dataOfMetadata = convertGeneralReport05Value({
          clinic: metadata,
          type: 'clinic',
          typeHook: 'week',
        })

        const totalTable: IDataReport05Weekly = {
          key: dataTable?.length + 1,
          area: 'Tổng',
          isTotalTable: true,
          ...dataOfMetadata,
          totalRevenueMonth: metadata?.totalActual ?? 0,
        }

        return {
          pagination: pagination ?? initialPagination,
          data: [...dataTable, totalTable],
        } as IDataBaseTable<IDataReport05Weekly>
      }
      return initData
    } catch (error) {
      return initData
    }
  }

  const {
    tableData,
    expandedRowKeys,
    handleExpand,
    handleTableChange,
    handleResetExpand,
    fetch,
    fetchLoading,
  } = useBaseTableReportHook({ getTreeTableData: getDataWeek })

  const { columns, exportExcel } = useCommonHook({
    expandedRowKeys,
    fetch,
    fetchLoading,
    handleExpand,
    typeHook: 'week',
    currentFilter: props,
  })

  return {
    columns,
    tableData,
    handleTableChange,
    handleExpand,
    expandedRowKeys,
    exportExcel,
    handleResetExpand,
    fetch,
    fetchLoading,
  }
}
